import { z } from "zod"

export const TicketIntegrationKindSchema = z.enum(["Zendesk", "Gorgias", "FrontApp"])

export const KnowledgeSuggestionSourceSchema = z.object({
  ticketKind: TicketIntegrationKindSchema,
  externalTicketId: z.string(),
  externalMessageId: z.string(),
  url: z.string().url(),
  excerpt: z.string().min(1),
  // Permut conversations whose questions are linked to the ticket; older suggestions have none.
  conversations: z.array(z.object({ id: z.string(), customerId: z.string() })).default([]),
})

export const KnowledgeSuggestionSchema = z.object({
  question: z.string().trim().min(1).max(1000),
  answer: z.string().trim().min(1).max(12000),
  sources: z.array(KnowledgeSuggestionSourceSchema).min(1),
})

export const KnowledgeSuggestionResultSchema = z.object({
  reason: z.string(),
  proposal: KnowledgeSuggestionSchema.nullable(),
})

export const KnowledgeGapResolutionSchema = z.enum(["knowledgeBase", "metafield", "capability"])

export const KnowledgeSuggestionStatusSchema = z.enum([
  "pending",
  "ready",
  "insufficient",
  "covered",
  "failed",
  "published",
])

// Analyzed gaps without a proposal that a reviewer can still answer manually.
export const MANUAL_KNOWLEDGE_SUGGESTION_STATUSES = ["insufficient", "covered", "failed"] as const

export const KnowledgeSuggestionsResponseDataSchema = z.array(
  z.object({
    id: z.bigint().transform(String),
    question: z.string(),
    category: z.string().nullable(),
    sampledQuestionCount: z.number(),
    generatedAt: z.date().transform((date) => date.toISOString()),
    suggestedAt: z
      .date()
      .nullable()
      .transform((date) => date?.toISOString() ?? null),
    status: KnowledgeSuggestionStatusSchema,
    result: KnowledgeSuggestionResultSchema.nullable(),
    publishedKnowledgeBaseItemId: z
      .bigint()
      .nullable()
      .transform((id) => id?.toString() ?? null),
  }),
)

export const KnowledgeSuggestionParamsSchema = z.object({
  gapId: z
    .string()
    .regex(/^[1-9]\d*$/)
    .transform(BigInt),
})

export const PublishKnowledgeSuggestionSchema = KnowledgeSuggestionSchema.pick({
  question: true,
  answer: true,
})

export const DismissKnowledgeSuggestionResponseDataSchema = z.object({
  dismissedAt: z.date().transform((date) => date.toISOString()),
})

export const PublishKnowledgeSuggestionResponseDataSchema = z.object({
  knowledgeBaseItemId: z.bigint().transform(String),
})
